import {Config} from "./config-viewmodel";

export interface ActivationModelState {
    config: Config
    toggle_modal: boolean
}

export class WidgetState implements ActivationModelState {
    config: Config = {
        eventListener: '',
        labels: {
            myStudyChoice: '',
            wouldYouLikeToActivate: '',
            iAmInterestedIn: '',
            iAmInterestedInBachelor: '',
            iAmInterestedInMaster: '',
            iAmInterestedInBoth: '',
            viaMyAccountYouCanChange: '',
            yesPlease: '',
            noThankYou: '',
            withAMyStudyChoiceAccountYouCan: '',
            registerForStudyChoiceActivities: '',
            youCanEasilyRegisterForAnOpenDay: '',
            saveYourFavoriteProgrammes: '',
            haveYouFoundOneOrMoreInterestingProgrammes: '',
            manageYourPersonalInfo: '',
            withAMyStudyChoiceAccountYouCanManage: ''
        },
    }
    toggle_modal = false
}
